import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { CtAdminLicenseList } from 'containers';
import { LicenseMenu, AdminPageTitle, AdminPageTemplate } from 'components';

class CtAdminLicense extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <AdminPageTemplate className="table">
        <AdminPageTitle
          type="table"
          title={defineMessages(formatMessage({ id: 'CtAdminLicense_1', defaultMessage: '라이센스' }))}>
          <LicenseMenu />
        </AdminPageTitle>
        <CtAdminLicenseList />
      </AdminPageTemplate>
    );
  }
}

CtAdminLicense.propTypes = {};
CtAdminLicense.defaultProps = {};

export default injectIntl(CtAdminLicense);



// WEBPACK FOOTER //
// ./src/script/containers/admin/license/CtAdminLicense.js